/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateClientRequest
 */
export interface UpdateClientRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateClientRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientRequest
     */
    lastName: string;
}

/**
 * Check if a given object implements the UpdateClientRequest interface.
 */
export function instanceOfUpdateClientRequest(value: object): value is UpdateClientRequest {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function UpdateClientRequestFromJSON(json: any): UpdateClientRequest {
    return UpdateClientRequestFromJSONTyped(json, false);
}

export function UpdateClientRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClientRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}

export function UpdateClientRequestToJSON(json: any): UpdateClientRequest {
    return UpdateClientRequestToJSONTyped(json, false);
}

export function UpdateClientRequestToJSONTyped(value?: UpdateClientRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}

